import React, {useState, useEffect, useContext, Fragment} from "react";
import {LoaderContext} from "../../context/LoaderContext";
import {
    getDataFormattata,
    getUtenteFromToken, STATO_CERTIFICATO_IN_APPROVAZIONE,
    TIPO_MODULO_CERTIFICATO_VEICOLO
} from "../../utility/common";
import ModuloPagamentoQuota from "../pagamenti/ModuloPagamentoQuota";
import {useHistory, useParams} from "react-router-dom";
import {RuoliContext} from "../../context/RuoliContext";
import AddQuotaCertificato from "./AddQuotaCertificato";
import Card from "../../components/Card";
import NsDataTable from "../../components/tabelle/NsDataTable";
import ModalMsg from "../../components/ModalMsg";
import NsBtnBack from "../../components/buttons/NsBtnBack";
import {getQuoteApi} from "../../services/QuoteServices";
import {getUtenteByIdApi} from "../../services/UtentiServices";
import {aggiornaStatoCertificatoApi, getCertificatoByIdApi} from "../../services/CertificatiServices";

export default function PagamentoQuotaCertificato() {
    const {idCertificato} = useParams()

    const [socio, setSocio] = useState();
    const [loadingData, setLoadingData] = useState(true);
    const [quote, setQuote] = useState([]);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [certificato, setCertificato] = useState();

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {isRuoloSocio, isRuoloClub, isRuoloAgenzia} = useContext(RuoliContext);

    const history = useHistory();

    async function getQuote() {
        startChiamata();

        const response = await getQuoteApi({
            quoteVeicoli: '1',
            attiva: '1',
            id_certificato: idCertificato
        });
        endChiamata();
        setQuote(response.data.data);
        setLoadingData(false);
    }

    async function getSocio() {
        let token = localStorage.getItem('rfi-login');
        if (token) {
            let user = getUtenteFromToken(token);
            if (user) {
                startChiamata();

                const response = await getUtenteByIdApi(user.id_utente);
                let val = response.data.data;
                setLoadingData(false);
                setSocio(val);
                endChiamata();
            }
        }
    }

    async function getCertificato() {
        startChiamata();
        const response = await getCertificatoByIdApi(idCertificato);
        setCertificato(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        if (loadingData) {
            getQuote();
            getSocio();
            getCertificato();
        }
    }, [idCertificato]);

    async function approvaCertificato() {
        if (isRuoloSocio() || isRuoloClub() || isRuoloAgenzia()) {
            let newCert = certificato;
            newCert.stato = STATO_CERTIFICATO_IN_APPROVAZIONE;

            startChiamata();

            const response = await aggiornaStatoCertificatoApi(idCertificato, newCert);
            endChiamata();

            if (response.data.result !== 0) {
                setModalMsg(response.data.description);
                setShow(true);
            } else {
                history.push("/list-certificati");
            }
        } else {
            history.push("/info-certificato/" + idCertificato)
        }
    }

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            {
                loadingData === false &&
                <Fragment>
                    {
                        quote && quote.length > 0 ?
                            <Card
                                icon={'fas fa-credit-card'}
                                title={'Quota Certificato'}
                                getBottoniDx={() =>
                                    <Fragment>
                                        <NsBtnBack/>
                                        <button
                                            type={"button"}
                                            className="btn btn-card"
                                            data-toggle="tooltip" title="Fine"
                                            onClick={approvaCertificato}
                                        >
                                            <i className="fas fa-angle-right"/> Fine
                                        </button>
                                    </Fragment>
                                }>
                                <div className={"row m-4"}>
                                    <div className={"col-md-12 text-center"}>
                                        <h3>Quota già versata</h3>
                                    </div>
                                </div>
                                <NsDataTable
                                    data={quote}
                                    columns={[
                                        {
                                            name: 'Data',
                                            selector: row => getDataFormattata(row.data_pagamento),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Oggetto',
                                            selector: row => row.tipo_versamento,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Importo €',
                                            selector: row => row.importo,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Modalità di pagamento',
                                            selector: row => row.modalita,
                                            sortable: true,
                                        }
                                    ]}
                                    addPagination={false}
                                    addFiltri={false}
                                />
                            </Card>
                            :
                            <Fragment>
                                {
                                    socio &&
                                    <Fragment>
                                        {
                                            (isRuoloSocio() || isRuoloClub() || isRuoloAgenzia()) ?
                                                <ModuloPagamentoQuota
                                                    usr={socio}
                                                    tipo={TIPO_MODULO_CERTIFICATO_VEICOLO}
                                                    idCertificato={idCertificato} />
                                                : <Fragment>
                                                    <AddQuotaCertificato
                                                        usr={socio}
                                                        idCertificato={idCertificato} />
                                                </Fragment>
                                        }
                                    </Fragment>
                                }
                            </Fragment>
                    }
                </Fragment>
            }
        </Fragment>
    );

}